export default __webpack_public_path__ + "static/media/jays-house.584841e1.webp";